import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors'
import { LanguageListApiResponse, TagsListApiResponse } from '@/types/api'

export const LanguageApi = {
    async getAll () {
        try {
            const { Data } = await $axios.post('/Language/List/', {}) as LanguageListApiResponse

            return Data
        } catch (e) {
            parseCatch(e, false)
        }
    }
}

export const ContentsApi = {
    async getAll () {
        try {
            const { Data } = await $axios.post('/Contents/TagsList/', {}) as TagsListApiResponse

            return Data
        } catch (e) {
            parseCatch(e, false)
        }
    }
}
